<template>
  <section class="mt-4 mb-4">
    <vue-headful
      :title="`ติดต่อปืนธง - Thong Firearms ร้านปืนธง`"
      image="https://thongarms.com/dist/logo.png"
      lang="th"
    />
    <div class="container">
      <h1 class="text-center">ติดต่อเรา</h1>
      <div class="row">
        <div class="col-md-6">
          <h5></h5>
          <p>ห้างหุ้นส่วนจำกัด ปืนธง</p>
          <p>ห้างหุ้นส่วนจำกัด ปืนฟีนิกซ์</p>
          <p>ห้างหุ้นส่วนจำกัด ปืนวิคทอรี่</p>
          <p>ห้างหุ้นส่วนจำกัด ปืนธนิสร์</p>
          <p>ห้างหุ้นส่วนจำกัด ปืนฉัตรชัย</p>
          <br>
          <p>
            ที่อยู่ : 5 ถนนบูรพา แขวงวังบูรพาภิรมย์ เขตพระนคร กรุงเทพมหานคร
            10200
          </p>
          <hr>
          <p>Thong Firearms Ltd., Part.</p>
          <p>Phoenix Firearms Ltd., Part.</p>
          <p>Victory Firearms Ltd., Part.</p>
          <p>Tanis Firearms Ltd., Part.</p>
          <p>Chutchai Firearms., Part.</p>
          <br>
          <p>Address: 5 Burapha Road, Wang Burapha Phirom Sub-district, Phra Nakhon District, Bangkok.</p>
          <hr>
          <p>วันทำการ : จันทร์ - เสาร์</p>
          <p>เวลา : 9:00 น. - 17:00 น.</p>
          <p class="">
            <a
              class="text-info d-flex align-items-center"
              target="_bank"
              href="tel:+6622227784"
              ><i class="fas fa-phone-square font-size-25"></i>&nbsp; 02-222-7784</a
            >
            <!-- <a
            class="text-success d-flex align-items-center"
            target="_bank"
            href="tel:+66651989891"
            ><i class="fas fa-phone-square font-size-25"></i>&nbsp; 065-198-9891</a
          > -->
          </p>
          <p class="">
            <a
              class="text-secondary d-flex align-items-center"
              target="_bank"
              href="mailto:info@thongarms.com"
              ><i class="fas fa-envelope font-size-25"></i>&nbsp;
              info&#64;thongarms.com</a
            >
          </p>
          <p>
            <a
              class="text-primary d-flex align-items-center"
              target="_bank"
              href="https://www.facebook.com/profile.php?id=61569913006234"
              ><i class="fab font-size-25 fa-facebook-square "></i>&nbsp; ปืนธง Thong
            </a>
          </p>
          <p>
            <a
              class="text-dark d-flex align-items-center"
              target="_bank"
              href="https://www.instagram.com/thongfirearms/profilecard"
            >
              <i class="fab font-size-25 fa-instagram"></i>&nbsp; @thongfirearms
            </a>
          </p>
          <p>
            <a
              class="text-success d-flex align-items-center"
              target="_bank"
              href="line://ti/p/%40nbq8455j"
              ><i class="fab font-size-25 fa-line"></i>&nbsp; @thong.arms</a
            >
          </p>
          <div class="row">
            <!-- <div class="col-6">
              <img
                src="/src/assets/line.jpg"
                alt="line thongarms"
                class="mw-100"
              />
            </div> -->
            <div class="col-6">
              <img
                src="/src/assets/lineadd.jpg"
                alt="line@ thongarms"
                class="mw-100"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <h5 class="mt-3 mt-md-0">กรอกข้อความเพื่อติดต่อเรา</h5>
          <form
            class="gform"
            accept-charset="UTF-8"
            autocomplete="off"
            :action="apiUrl"
            method="POST"
            data-email="thongarm.app@gmail.com"
            :reset="true"
          >
            <!-- <form accept-charset="UTF-8" autocomplete="off" action="https://script.google.com/macros/s/AKfycbzvKKDMDNVykQftzsGqRd0FovmdfL4j3Smkmgbd/exec" method="POST" data-email="thongarm.app@gmail.com" :reset="true"> -->

            <div class="form-group">
              <label for="name">ชื่อ - นามสกุล :</label>
              <input
                type="text"
                name="name"
                v-model="form.name"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="phone">โทร :</label>
              <input
                type="tel"
                name="phone"
                v-model="form.phone"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="email">อีเมล :</label>
              <input
                id="email"
                name="email"
                type="email"
                v-model="form.toEmailAddresses"
                value=""
                required
                autocomplete="no"
                class="form-control"
              />
              <span class="email-invalid" style="display:none">
                กรุณาใส่อีเมลให้ถูกต้อง</span
              >
            </div>
            <!-- <div class="form-group">
                            <label for="">เรื่อง :</label>
                            <input type="text" name="subject" class="form-control">
                        </div> -->
            <div class="form-group">
              <label for="message">ข้อความ :</label>
              <textarea
                name="message"
                id="message"
                rows="3"
                v-model="form.emailText"
                class="form-control"
              ></textarea>
            </div>
            <div class="form-group row">
              <div class="col-12">
                <!-- <button type="submit" v-on:click.prevent="onSubmit" class="btn btn-primary">Submit</button> -->
                <!-- <button type="submit" class="btn-width btn btn-outline-dark">ส่งข้อความ</button> &nbsp;&nbsp; -->
                <button class="btn btn-outline-dark">
                  <i class="fa fa-paper-plane"></i>&nbsp;ส่งข้อความ
                </button>

                <button type="reset" class="btn-width btn btn-outline-dark">
                  ยกเลิก
                </button>
              </div>
              <div class="col-6">
                {{ results }}
                <div class="thankyou_message" style="display:none;">
                  <p style="color:green">
                    <em>ส่งข้อความสำเร็จแล้ว!</em> เราจะติดต่อกลับหาคุณเร็วๆ นี้
                    ขอบคุณครับ
                  </p>
                </div>
              </div>
            </div>
          </form>
          <iframe
        title="แผนที่ร้านปืนธง ขายปืน วังบูรพา"
        class="mt-3"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3875.536262672678!2d100.49878466540672!3d13.746502740350891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29910abc291fd%3A0xba83e19983b0357!2z4Lib4Li34LiZ4LiY4LiH!5e0!3m2!1sth!2sth!4v1530179605854"
        height="450"
        frameborder="0"
        style="border:0"
        allowfullscreen
      ></iframe>
        </div>
        
      </div>
    </div>
  </section>
</template>

<script>
// import {HTTP} from '../http-common';
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      // apikey: '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',
      form: {
        name: null,
        toEmailAddresses: null,
        // subject: null,
        emailText: null,
        phone: null
      },
      apiUrl:
        "https://script.google.com/macros/s/AKfycbzvKKDMDNVykQftzsGqRd0FovmdfL4j3Smkmgbd/exec",
      results: ""
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      // let method = this.method;
      // this.$http[method](this.action, this.form)
      // this.$http.post(this.apiUrl, this.form).then(function(response) {
      //       console.log(response);
      //   }, function() {
      //       console.log('failed');
      //   });
      this.results = "Done!";
    }
  },
  // computed: {
  //     form_method: function () {
  //         return this.$el.method.toLowerCase();
  //     },
  //     form_action: function () {
  //         return this.$el.action.toLowerCase();
  //     },
  // },

  // methods: {
  //     onSubmit: function (e) {
  //         var formData = new FormData(this.$el);

  //         this.$http[this.form_method](this.form_action, formData)
  //                 .then(this.successCallBack, this.errorCallBack);
  //     },

  //     successCallBack: function (response) {
  //         console.log('AjaxForm submission: SUCCESS');
  //     },

  //     errorCallBack: function (response) {
  //         console.log('AjaxForm submission: ERROR');
  //     },
  // },
  // bind: function (el, binding, vnode) {
  //     el.addEventListener(
  //         'submit', function(e){
  //             e.preventDefault();

  //             let button = el.querySelector('button[type="submit"]');
  //             button.disabled = true;
  //             let resetForm = true
  //             let formData = new FormData(el)

  //             let formInstance = el
  //             let method = el.method.toLowerCase();
  //             Vue.http[method](el.action, formData)
  //                 .then(function(response){

  //                     if(response.data.success && resetForm)
  //                     {
  //                         formInstance.reset();
  //                         this.results = response.data;
  //                         // show success message here, I prefer noty
  //                     }

  //                     button.disabled = false;
  //                 })
  //         }
  //     );
  // }
  //   methods: {
  //         formSubmit(e) {
  //             e.preventDefault();
  //             // let mailBody = JSON.stringify({
  //             //     personalizations: [
  //             //             {
  //             //             to: [
  //             //                 {
  //             //                 email: 'ctben.lf@gmail.com'
  //             //                 }
  //             //             ],
  //             //             subject: this.form.subject
  //             //             }
  //             //         ],
  //             //         from: {
  //             //             email: "web@example.com"
  //             //         },
  //             //         content: [
  //             //             {
  //             //             type: 'text/plain',
  //             //             value: this.form.emailText
  //             //             }
  //             //         ]
  //             // });
  //             alert(this.form);
  //             // console.log(mailBody);
  //                 console.log('submitting message...');
  //                 this.$http({url: 'https://script.google.com/macros/s/AKfycbxYxEMoRbTGQXNw3R4-M-ycTZJHzoHRmoDHV5i8zA/exec', method: 'POST', data: this.form}).then(function () {
  //                     alert('Your form was submitted!');
  //                 }, function () {
  //                     alert('Form submission failed');
  //                 }).then((response) => {
  //                     this.results = response.data
  //                 });
  //             // let currentObj = this;
  //             // axios.post('https://api.sendgrid.com/v3/mail/send', mailBody, {
  //             //     headers: {
  //             //         'Authorization': 'Bearer ' + this.apikey,
  //             //         'Content-Type': 'application/json',
  //             //         'Access-Control-Allow-Origin': '*',
  //             //         'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
  //             //         'Access-Control-Allow-Headers':'X-Requested-With',
  //             //         'Access-Control-Allow-Credentials': 'false',
  //             //         'crossDomain': true,
  //             //     }
  //             // });
  //             // HTTP.post(mailBody)
  //             // .then((response) => {
  //             //     this.results = response.data
  //             // });
  //             // .catch(function (error) {
  //             //     this.results = error;
  //             // });
  //         }
  //     },
  onReset(evt) {
    evt.preventDefault();
    /* Reset our form values */
    this.form.name = "";
    this.form.toEmailAddresses = "";
    // this.form.subject = '';
    this.form.emailText = "";
    /* Trick to reset/clear native browser form validation state */
    this.show = false;
    this.$nextTick(() => {
      this.show = true;
    });
  }
};
</script>

<style scoped>
.btn-outline-dark:hover {
  border-color: red;
  background: red;
  color: #fff;
}
.btn-width {
  width: 93px;
}
iframe {
  width: 100%;
  height: 250px;
}
p {
  margin-bottom: 5px;
}
p a {
  color: black;
}
a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/component/contactUs.vue